module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-h"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('strong', [_c('em', [_vm._v("A note from the author about dialogue in Pistaco")])])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "fm-p"
  }, [_vm._v("The characters in a story taking place in Peru would normally speak Spanish, the country’s principal language, or Quechua, the tongue of the Inca empire still spoken in places like the fictional village of Urpimarca, where "), _c('em', [_vm._v("Pistaco’s")]), _vm._v(" main action takes place. Most of this book’s dialogue, whether Spanish or Quechua, is rendered in English, though I have kept a few phrases of those languages to help retain a sense of the atmosphere of the Peruvian highlands.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_vm._v("A glossary of Spanish and Quechua words and phrases appearing in the book is appended after the last chapter for the reader’s convenience.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-p"
  }, [_c('em', [_vm._v("Pistaco")]), _vm._v(" is a work of fiction. Aside from references to a few historic figures mentioned by name, any similarity to actual people, living or dead, is coincidental.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a8c92d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_FM.vue
// module id = 66
// module chunks = 0